import {
  ORDER_CATEGORY_DISPLAY_MAP,
  ORDER_STATUS,
  type OrderStatus,
  RETIRED_ORDER_CATEGORY_LABELS,
} from '@seen/core/models/orders/constants'
import { recordEntries } from '@seen/core/utils'

export const defaultOrderStatusOptions = getOrderStatusOptions(true) as {
  value: OrderStatus
  label: string
}[]

export const orderCategoryOptions = recordEntries(
  ORDER_CATEGORY_DISPLAY_MAP
).map(([value, label]) => ({
  value,
  label,
}))

// Filters still find orders stored under a retired category; create and edit
// pickers use orderCategoryOptions.
export const orderCategoryFilterOptions = [
  ...orderCategoryOptions,
  ...recordEntries(RETIRED_ORDER_CATEGORY_LABELS).map(([value, label]) => ({
    value,
    label,
  })),
]

function getOrderStatusOptions(
  includeRevoked = false
): { value: OrderStatus; label: string }[] {
  return recordEntries(ORDER_STATUS)
    .filter(([value]) => includeRevoked || value !== 'revoked')
    .map(([value, label]) => ({
      value,
      label,
    }))
}
